const NotFound = () => (
  <div style={{ display: "flex", justifyContent: "center", marginTop: "2em" }}>
    <h1>Sorry, this page does not exist</h1>
  </div>
);

export default NotFound;
